import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const AttributeEdit = () => {
  const users = {
    attr_name: "",
    attr_value: "",
    status: "",
  };

  const [AttributeEditUser, setAttributeEditUser] = useState(users);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPedagogyData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_attribute_by_id",
          {
            attr_id: id,
          }
        );
        setAttributeEditUser(response.data.data);
      } catch (error) {
        console.error("Error fetching Pedagogy data!", error);
      }
    };

    fetchPedagogyData();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setAttributeEditUser({ ...AttributeEditUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_attribute",
        {
          attr_id: id,
          ...AttributeEditUser,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    
        toast.success(response.data.message || "Data Updated Successfully!");
        navigate("/Attribute-list");

    } catch (error) {
      console.error(
        "There was an error!",
        error.response?.data || error.message
      );
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Attribute Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Attribute</a>
                </li>
                <li className="breadcrumb-item active">Attribute Edit</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Attribute</h4>
              </div>
              <form onSubmit={submitForm}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="attr_name"
                          className="form-label text-dark"
                        >
                          Attribute Name
                        </label>
                        <input
                          type="text"
                          id="attr_name"
                          name="attr_name"
                          className="form-control"
                          placeholder="Enter Name"
                          value={AttributeEditUser.attr_name}
                          onChange={changeHandler}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="attr_value"
                          className="form-label text-dark"
                        >
                          Attribute Value
                        </label>
                        <input
                          type="text"
                          id="attr_value"
                          name="attr_value"
                          className="form-control"
                          placeholder="Enter Value"
                          value={AttributeEditUser.attr_value}
                          onChange={changeHandler}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          className="form-control"
                          id="status"
                          name="status"
                          value={AttributeEditUser.status}
                          onChange={changeHandler}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer border-top">
                  <button type="submit" className="btn btn-primary">
                    Edit Change
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default AttributeEdit;
